export default __webpack_public_path__ + "static/media/bg.28afe0b8.svg";